<template lang="pug">
.rel.wh100p
	.abs(:style="bg_style")
	v-layout(row wrap justify-center align-center).abs.wh100p
		v-flex(xs12 sm8 md6 lg4)
			v-img(:src="twbus" max-width="260" contain class="mx-auto mb-4")
			v-text-field(dark v-model="account" prepend-icon="mdi-account"
				label="帳號" @keyup.enter="login").bdr.orange.darken-2.mx-3.px-3
			v-text-field(dark v-model="password" prepend-icon="mdi-lock"
				label="密碼" type="password" @keyup.enter="login").bdr.orange.darken-2.mx-3.px-3
			.d-flex.px-3.py-1
				v-spacer
				v-btn(dark @click="login").orange.darken-2 登入
</template>

<script>
import { bus, db, auth } from '../main';
import twbus from '@/assets/tw-bus2.png';
import bgimg from '@/assets/bg-img2.png';
import axios from 'axios';

export default {
    name: 'login',
    data() {
        return {
            twbus,
            bg_style: {
                width: '100%',
                height: '100%',
                background: `url(${bgimg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'blur(5px)',
            },
            account: '',
            password: '',
            loading: false,
            errorMessage: '',
        };
    },
    methods: {
        login() {
            if (!this.account || !this.password) {
                this.errorMessage = '請輸入帳號和密碼';
                return;
            }

            this.loading = true;
            this.errorMessage = '';

            axios.post('/api/Login', {
                account: this.account,
                password: this.password
            })
            .then((response) => {
                if (response.data.status) {
                    const token = response.data.result.token;
                    const userData = response.data.result;

                    localStorage.setItem('token', token);
                    localStorage.setItem('user', JSON.stringify(userData));
                    
                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                    bus.$emit('login', userData);
                    
                    this.$router.replace('/checkin');
                } else {
                    this.errorMessage = response.data.message || '登入失敗';
                }
            })
        },
    },
};
</script>
